<template>
  <div class="modal-window alert ab001">
    <header class="modal-header" style="height:31px;">
      <div class="tit">{{ modalInfo.title }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>
    
    <div class="modal-content">
      <div class="info-txt small">{{ modalInfo.contents }}</div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty2" @click="$emit('close')">{{ $i18nUtil.trans("button.cancel","취소") }}</button> 
      <button type="button" class="btn_ty1" @click="onSubmit()">{{ modalInfo.btnName }}</button>
    </footer>
  </div>
</template>
<script>

export default {
  props:{
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data() {
    return { 
      error: true,
    };
  },
  methods: {
    onSubmit() {
      let obj = this;
      let modalName = obj.modalInfo.name;

      if(modalName == "restoreFileVersion") {
        obj.$emit("restoreFileVersion", obj.modalInfo);
        obj.$emit("close");
      } else if(modalName == "deleteFile") {
        obj.$emit("deleteFile", obj.modalInfo);
        obj.$emit("close");
      } else if(modalName == "deleteOpinion") {
        obj.$emit("deleteOpinion", obj.modalInfo);
        obj.$emit("close");
      } else if(modalName == "deleteComment") {
        obj.$emit("deleteOpinion", obj.modalInfo);
        obj.$emit("close");
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/file/modal/ViewerConfirmModal.vue